module.exports = __webpack_public_path__ + "img/1530460247.505e34ed.jpg";